import { gql } from '@apollo/client'
import { GraphQLContext } from '@moonpig/web-core-graphql'
import { logger } from '@moonpig/web-core-monitoring'
import { EppoClient } from '@moonpig/web-core-eppo/server'
import { getCookie } from '@moonpig/web-core-browser-storage'
import { NextPageContext } from 'next'
import { EppoCustomerIdQuery } from './__generated__/getEppoCustomerId'

type GetEppoCustomerIdArgs = {
  isBot?: boolean
  isLoggedIn?: boolean
  graphQLContext: GraphQLContext
  eppoClient: EppoClient | null
  subjectKey: string
  nextPageContext: NextPageContext
}

type GetEppoCustomerId = (args: GetEppoCustomerIdArgs) => Promise<string | null>

export const getEppoCustomerId: GetEppoCustomerId = async ({
  isBot = false,
  isLoggedIn,
  graphQLContext: { query },
  eppoClient,
  subjectKey,
  nextPageContext,
}) => {
  const isEnabled = eppoClient?.getBooleanAssignment(
    'enable-eppo-customer-id-query',
    subjectKey,
    {},
    false,
  )

  if (isBot || !isEnabled || !isLoggedIn) {
    logger.info('Skipping customer id query')
    return null
  }

  const cachedCustomerId = getCookie(nextPageContext, 'mnpg_eppo_customer_id')

  if (cachedCustomerId) {
    logger.info('Using cached customer id cookie')
    return cachedCustomerId
  }

  try {
    const { data } = await query<EppoCustomerIdQuery, Record<string, unknown>>({
      query: gql`
        query EppoCustomerIdQuery {
          me {
            customer {
              id
            }
          }
        }
      `,
    })

    return data.me?.customer?.id ?? null
  } catch (error) {
    logger.warning(`Error fetching customer id: ${error.message}`)
    return null
  }
}
